module.exports = __webpack_public_path__ + "img/zp.39e24e8b.png";